import { ReactComponent as arrowRight } from './arrow-right.svg'
import { ReactComponent as arrowDown } from './arrow-down.svg'
import { ReactComponent as arrowUp } from './arrow-up.svg'
import { ReactComponent as information } from './information.svg'
import { ReactComponent as download } from './download.svg'
import { ReactComponent as upload } from './upload.svg'
import { ReactComponent as maf } from './maf.svg'
import { ReactComponent as notifications } from './notifications.svg'
import { ReactComponent as settings } from './settings.svg'
import { ReactComponent as pointerRight } from './pointer-right.svg'
import { ReactComponent as empty } from './empty.svg'
import { ReactComponent as eye } from './eye.svg'
import { ReactComponent as trash } from './trash.svg'
import { ReactComponent as expand } from './expand.svg'
import { ReactComponent as showMore } from './showMore.svg'
import { ReactComponent as top10question } from './top10question.svg';
import { ReactComponent as dropdownTriangle } from './dropdownTriangle.svg';
import { ReactComponent as draggable } from './draggable.svg';
import { ReactComponent as transfer } from './transfer.svg';
import { ReactComponent as settlement } from './settlement.svg';
import { ReactComponent as briefCase } from './briefcase.svg';
import { ReactComponent as fileText } from './filetext.svg';


import * as etoIcons from '../wl/19/icons';
export default {
  arrowRight,
  information,
  download,
  upload,
  maf,
  empty,
  eye,
  trash,
  notifications,
  settings,
  pointerRight,
  expand,
  showMore,
  top10question,
  dropdownTriangle,
  draggable,
  transfer,
  settlement,
  arrowDown,
  arrowUp,
  briefCase,
  fileText,
  ...etoIcons
} as any;
